// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zsi9Gi4mrewIzj3Bdmmt{flex-direction:column;gap:16px;padding-top:2px;padding-bottom:3px;display:flex}.QatTbYRjMsmXmIWLIKNm{flex-direction:column;display:flex}._j0cABPfQ8XHP074xQQE{flex-direction:column;gap:24px;display:flex}.MCXmQSqaz_oj3mUcnvnY{margin-top:3px;margin-left:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zsi9Gi4mrewIzj3Bdmmt`,
	"messageBlock": `QatTbYRjMsmXmIWLIKNm`,
	"categories": `_j0cABPfQ8XHP074xQQE`,
	"error": `MCXmQSqaz_oj3mUcnvnY`
};
export default ___CSS_LOADER_EXPORT___;
